<template>
  <div class="flex items-start justify-between space-x-4">
    <div class="flex-1">
      <p>{{ title }}</p>
      <p class="text-xs text-gray-500">{{ description }}</p>
    </div>
    <div
      class="flex w-40 items-center justify-between rounded-xl bg-gray-75 p-1"
    >
      <PassengerAmountButton :disabled="value === min" @click="decrease">
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" fill="none" class="stroke-current"><path stroke="currentStroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.334 1H1.667"/></svg>
      </PassengerAmountButton>
      <p class="font-semibold">{{ value }}</p>
      <PassengerAmountButton :disabled="isMax" @click="increase">
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" class="stroke-current"><path stroke="currentStroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 1.667v10.666M12.334 7H1.667"/></svg>
      </PassengerAmountButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import PassengerAmountButton from './PassengerAmountButton.vue';

  const props = withDefaults(
    defineProps<{
      min?: number;
      value: number;
      title: string;
      description: string;
      isMax?: boolean;
    }>(),
    {
      min: 0,
    },
  );

  const emit = defineEmits<{
    change: [value: number];
    onMin: [];
    onMax: [];
  }>();

  const increase = () => {
    if (props.isMax) {
      emit('onMax');
    } else {
      emit('change', props.value + 1);
    }
  };

  const decrease = () => {
    if (props.value - 1 < props.min) {
      emit('onMin');
    } else {
      emit('change', props.value - 1);
    }
  };
</script>
